import React from "react";
import PropTypes from "prop-types";
import ContentKeyList from "../ContentKeyList";
import { Key, StyledHeading } from "./_.styled";

const ContentKey = ({ label, content, testId }) => (
  <Key data-testid={testId}>
    <StyledHeading color="headingprimary" element="h2" fontFamily="secondary">
      {label}
    </StyledHeading>
    <ContentKeyList keys={content} />
  </Key>
);

ContentKey.propTypes = {
  label: PropTypes.string,
  testId: PropTypes.string.isRequired,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      icon: PropTypes.shape({
        glyph: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
        size: PropTypes.string.isRequired,
        testId: PropTypes.string.isRequired,
      }),
      testId: PropTypes.string.isRequired,
      style: PropTypes.string,
      value: PropTypes.string.isRequired,
    })
  ),
};

ContentKey.displayName = "ContentKey";

export default ContentKey;
